/**
 * Chart color helpers. Recharts accepts string props (fill, stroke) — it
 * won't consume Tailwind classes directly, so we resolve CSS custom
 * properties at render time. Fallbacks are used during SSR / tests.
 */
function cssVar(name: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return v || fallback;
}

export function chartColors() {
  return {
    primary: cssVar('--color-primary', '#2563eb'),
    muted: cssVar('--color-muted', '#f1f5f9'),
    mutedForeground: cssVar('--color-muted-foreground', '#64748b'),
    border: cssVar('--color-border', '#e2e8f0'),
    card: cssVar('--color-card', '#ffffff'),
    success: cssVar('--color-success', '#22c55e'),
    warning: cssVar('--color-warning', '#f59e0b'),
    danger: cssVar('--color-danger', '#ef4444'),
  };
}

/** Distinct categorical palette for donut/pie series — derived from the token system. */
export function categoricalPalette(): string[] {
  const c = chartColors();
  return [c.primary, c.success, c.warning, c.danger, c.mutedForeground];
}
